import { render, staticRenderFns } from "./WysiwygViewer.vue?vue&type=template&id=7fa54859&scoped=true"
import script from "./WysiwygViewer.vue?vue&type=script&lang=js"
export * from "./WysiwygViewer.vue?vue&type=script&lang=js"
import style0 from "./WysiwygViewer.vue?vue&type=style&index=0&id=7fa54859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa54859",
  null
  
)

export default component.exports